__turbopack_context__.v({
  "Radio": "radio-module__GEyccG__Radio",
  "checked": "radio-module__GEyccG__checked",
});
